import type { BillingEntity, BillingEntityInput } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

/** Who an organization's invoices go to: the organization itself and any own addresses. */
export const billingEntitiesApi = {
  async list(businessId: string): Promise<BillingEntity[]> {
    const res = await api.api['billing-entities'][':businessId'].$get({ param: { businessId } })
    return (await unwrap<{ entities: BillingEntity[] }>(res)).entities
  },

  async create(businessId: string, input: BillingEntityInput): Promise<BillingEntity> {
    const res = await api.api['billing-entities'][':businessId'].$post({
      param: { businessId },
      json: input,
    })
    return unwrap<BillingEntity>(res)
  },
}
